var $ = require("jquery");

export function highChart() {
    $(document).ready(function () {
    });
}
